import { formatCurrencyAmount, type FormatCurrencyOptions } from '~/shared-kernel/domain/currency'

/**
 * Single source of truth for formatting monetary amounts in templates across the app
 * (cart, POS sales, pricing, refunds, annulments, reports). Wraps the framework-agnostic
 * `formatCurrencyAmount` with the active i18n locale.
 *
 * Do not use this for values sent to the payment gateway or third-party integrations —
 * those keep their own untouched numeric/string contracts.
 */
export function useCurrencyFormatter() {
  const { locale } = useI18n()

  function formatMoney(amount: number, currency: string | null | undefined, options?: FormatCurrencyOptions) {
    return formatCurrencyAmount(amount, currency, locale.value, options)
  }

  return { formatMoney }
}
